export default "__VITE_ASSET__CvSU1zuP__"